<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" max-width="500px" :persistent="false">
      <v-form ref="form">
        <v-card
          v-if="item"
          :color="item.wip_panel_grouped_status ? item.wip_panel_grouped_status.color : '#FFFFFF'"
          class="rounded"
          style="padding: 5px 7px 5px 7px"
          tile
        >
          <v-card-title class="pt-3 pb-7">
            <v-row>
              <v-col>
                <v-row align="center">
                  <v-col class="pt-1 pb-1 pl-1">
                    <v-chip small color="#FFFFFF" text-color="#01579B">
                      {{ item.wip_panel_grouped_status ? item.wip_panel_grouped_status.name : '' }}
                    </v-chip>
                  </v-col>
                  <v-spacer />
                  <v-col class="pt-1 pb-1" cols="auto">
                    <v-btn
                      v-if="
                        roles.includes(userRoleIdAdmin) ||
                        roles.includes(userRoleIdPanelAdmin) ||
                        roles.includes(userRoleIdAssociate)
                      "
                      class="elevation-0"
                      color="#FFFFFF"
                      small
                      @click="toggle(item.id, item.status_id)"
                    >
                      <span style="color: #01579b">COMPLETE</span>
                    </v-btn>
                  </v-col>
                  <v-col cols="auto" class="pr-6 pl-0">
                    <v-menu offset-y v-if="isAdmin">
                      <template #activator="{ on, attrs }">
                        <v-btn
                          elevation="0"
                          fab
                          color="#FFFFFF"
                          x-small
                          v-bind="attrs"
                          tile
                          style="
                            border-radius: 7px;
                            width: 28px !important;
                            height: 28px !important;
                          "
                          v-on="on"
                        >
                          <v-icon style="color: #01579b">
                            mdi-dots-vertical
                          </v-icon>
                        </v-btn>
                      </template>
                      <v-list class="pa-3">
                        <v-list-item
                          v-if="
                            item.status_id === statusIdInProgress &&
                            (roles.includes(userRoleIdAdmin) ||
                              roles.includes(userRoleIdPanelAdmin))
                          "
                          @click="openEdit(item)"
                        >
                          <v-list-item-title
                            style="color: #1976d2; font-weight: 600"
                          >
                            EDIT
                          </v-list-item-title>
                        </v-list-item>
                        <v-list-item
                          v-if="
                            (roles.includes(userRoleIdAdmin) ||
                              roles.includes(userRoleIdPanelAdmin)) &&
                            item.status_id == statusIdInProgress
                          "
                          @click="softDelete(item.id)"
                        >
                          <v-list-item-title
                            style="color: #ff5252; font-weight: 600"
                          >
                            DELETE
                          </v-list-item-title>
                        </v-list-item>
                        <v-list-item
                          v-if="
                            roles.includes(userRoleIdAdmin) ||
                            roles.includes(userRoleIdPanelAdmin)
                          "
                          @click="openNotes(item)"
                        >
                          <v-list-item-title
                            style="color: #ff9800; font-weight: 600"
                          >
                            NOTES
                            {{ item.notes ? `(${item.notes.length})` : '' }}
                          </v-list-item-title>
                        </v-list-item>
                        <v-list-item
                          v-if="
                            (roles.includes(userRoleIdAdmin) ||
                              roles.includes(userRoleIdPanelAdmin)) &&
                            item.status_id == statusIdInProgress
                          "
                          @click="toggle(item.id, item.status_id, true)"
                        >
                          <v-list-item-title
                            style="color: purple; font-weight: 600"
                          >
                            ARCHIVE
                          </v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </v-col>
                </v-row>
              </v-col>
              <v-divider
                v-if="
                  $vuetify.breakpoint.name !== 'xs' &&
                  $vuetify.breakpoint.name !== 'sm'
                "
                vertical
                inset
                style="max-height: 30px; margin-top: 15px"
              />
              <v-col cols="auto" class="text-end pr-0">
                <v-btn icon @click="dialog = false">
                  <v-icon color="#FFFFFF"> mdi-close </v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-card-title>
          <v-card-text style="background-color: #ffffff; border-radius: 5px">
            <v-row
              style="
                min-height: 41px;
                border-bottom: 1px solid rgba(0, 0, 0, 0.1);
              "
              align="center"
            >
              <v-col cols="4" style="line-height: 16px">
                <span style="font-size: 16px; color: rgba(0, 0, 0, 0.8)"
                  >Class</span
                >
              </v-col>
              <v-col style="line-height: 16px">
                <v-chip
                  small
                  :color="item && item.class ? item.class.color : 'grey'"
                  text-color="white"
                >
                  {{ item && item.class ? item.class.name : '' }}
                </v-chip>
              </v-col>
            </v-row>
            <v-row
              style="
                min-height: 41px;
                border-bottom: 1px solid rgba(0, 0, 0, 0.1);
              "
            >
              <v-col cols="4" style="line-height: 16px">
                <span style="font-size: 16px; color: rgba(0, 0, 0, 0.8)"
                  >Project</span
                >
              </v-col>
              <v-col style="line-height: 16px">
                <span
                  style="font-size: 16px; color: #000000; line-height: 10px"
                  >{{ item.project }}</span
                >
              </v-col>
            </v-row>
            <v-row style="border-bottom: 1px solid rgba(0, 0, 0, 0.1)">
              <v-col cols="4" style="line-height: 16px">
                <span style="font-size: 16px; color: rgba(0, 0, 0, 0.8)"
                  >Floor</span
                >
              </v-col>
              <v-col style="line-height: 16px">
                <span
                  style="font-size: 16px; color: #000000; line-height: 10px"
                  >{{ item.project_floor }}</span
                >
              </v-col>
            </v-row>
            <v-row style="border-bottom: 1px solid rgba(0, 0, 0, 0.1)">
              <v-col cols="4" style="line-height: 16px">
                <span style="font-size: 16px; color: rgba(0, 0, 0, 0.8)"
                  >#WO</span
                >
              </v-col>
              <v-col style="line-height: 16px">
                <span
                  style="font-size: 16px; color: #000000; line-height: 10px"
                  >{{ item.wo_number }}</span
                >
              </v-col>
            </v-row>
            <v-row style="border-bottom: 1px solid rgba(0, 0, 0, 0.1)">
              <v-col cols="4" style="line-height: 16px">
                <span style="font-size: 16px; color: rgba(0, 0, 0, 0.8)"
                  >Total Qty</span
                >
              </v-col>
              <v-col style="line-height: 16px">
                <span
                  style="font-size: 16px; color: #000000; line-height: 10px"
                  >{{ item.wip_panel_quantity }}</span
                >
              </v-col>
            </v-row>
            <v-row
              style="border-bottom: 1px solid rgba(0, 0, 0, 0.1)"
              align="center"
            >
              <v-col cols="4" style="line-height: 16px">
                <span style="font-size: 16px; color: rgba(0, 0, 0, 0.8)"
                  >Stage</span
                >
              </v-col>
              <v-col
                v-for="(stage, index) in stages"
                :key="stage.statusId"
                :class="`${index == 0 ? '' : 'pr-1 pl-1'}`"
              >
                <div class="mb-1" style="font-size: 12px; font-weight: 500;">
                    {{ stage.name }}
                </div>
                <v-btn
                  v-if="stage.statusId != null"
                  elevation="0"
                  fab
                  outlined
                  tile
                  color="#FFD84D"
                  :class="`box ${getStageClass(item, stage)}`"
                  @click="openItemsForm(item, stage.statusId)"
                >
                  <span>{{ getStageValue(item, stage) }}</span>
                </v-btn>
                <div
                  v-else
                  class="pl-1"
                  style="
                    width: 1px;
                    height: 100%;
                    border-right: 1px solid #e0e0e0;
                  "
                />
              </v-col>
              <!-- <v-col cols="auto " style="line-height: 16px" class="pr-1 pl-1">
                <v-btn
                  elevation="0"
                  fab
                  outlined
                  tile
                  readonly
                  :ripple="false"
                  color="#FFD84D"
                  :style="`border-radius: 4px; width: 25px; height: 25px; border: 1.5px solid ${
                    item.total_cut > 0
                      ? '#FFD84D'
                      : item.is_assemble == 1
                      ? '#4CAF50'
                      : ''
                  }; background-color: ${
                    item.total_cut > 0
                      ? '#FFD84D'
                      : item.is_assemble == 1
                      ? '#4CAF50'
                      : ''
                  }`"
                  @click="
                    (roles.includes(userRoleIdAdmin) ||
                      roles.includes(userRoleIdPanelAdmin) ||
                      roles.includes(userRoleIdAssociate)) &&
                    item.total_cut > 0
                      ? openFinishedGoodForm(item, 3)
                      : ''
                  "
                >
                  <span v-if="item.total_cut > 0" style="color: #000000">{{
                    item.total_cut
                  }}</span>
                  <span v-else-if="item.is_assemble == 1" style="color: #ffffff"
                    >C</span
                  >
                  <span v-else style="color: #000000" />
                </v-btn>
              </v-col>
              <v-col cols="auto " style="line-height: 16px" class="pr-1 pl-1">
                <v-btn
                  elevation="0"
                  fab
                  outlined
                  tile
                  readonly
                  color="#FFD84D"
                  :style="`border-radius: 4px; width: 25px; height: 25px; border: 1.5px solid ${
                    item.total_assemble > 0
                      ? '#FFD84D'
                      : item.is_t_and_b == 1
                      ? '#4CAF50'
                      : ''
                  }; background-color: ${
                    item.total_assemble > 0
                      ? '#FFD84D'
                      : item.is_t_and_b == 1
                      ? '#4CAF50'
                      : ''
                  }`"
                  @click="
                    (roles.includes(userRoleIdAdmin) ||
                      roles.includes(userRoleIdPanelAdmin) ||
                      roles.includes(userRoleIdAssociate)) &&
                    item.total_assemble > 0
                      ? openFinishedGoodForm(item, 4)
                      : ''
                  "
                >
                  <span v-if="item.total_assemble > 0" style="color: #000000">{{
                    item.total_assemble
                  }}</span>
                  <span v-else-if="item.is_t_and_b == 1" style="color: #ffffff"
                    >A</span
                  >
                  <span v-else style="color: #000000" />
                </v-btn>
              </v-col>
              <v-col cols="auto " style="line-height: 16px" class="pr-1 pl-1">
                <v-btn
                  elevation="0"
                  fab
                  outlined
                  tile
                  readonly
                  color="#FFD84D"
                  :style="`border-radius: 4px; width: 25px; height: 25px; border: 1.5px solid ${
                    item.total_t_and_b > 0
                      ? '#FFD84D'
                      : item.is_glaze == 1
                      ? '#4CAF50'
                      : ''
                  }; background-color: ${
                    item.total_t_and_b > 0
                      ? '#FFD84D'
                      : item.is_glaze == 1
                      ? '#4CAF50'
                      : ''
                  }`"
                  @click="
                    (roles.includes(userRoleIdAdmin) ||
                      roles.includes(userRoleIdPanelAdmin) ||
                      roles.includes(userRoleIdAssociate)) &&
                    item.total_t_and_b > 0
                      ? openFinishedGoodForm(item, 5)
                      : ''
                  "
                >
                  <span v-if="item.total_t_and_b > 0" style="color: #000000">{{
                    item.total_t_and_b
                  }}</span>
                  <span v-else-if="item.is_glaze == 1" style="color: #ffffff"
                    >T</span
                  >
                  <span v-else style="color: #000000" />
                </v-btn>
              </v-col>
              <v-col cols="auto " style="line-height: 16px" class="pr-1 pl-1">
                <v-btn
                  elevation="0"
                  fab
                  outlined
                  tile
                  color="#FFD84D"
                  :style="`border-radius: 4px; width: 25px; height: 25px; border: 1.5px solid ${
                    item.total_glaze > 0
                      ? '#FFD84D'
                      : item.is_prod_backlog == 1
                      ? '#4CAF50'
                      : ''
                  }; background-color: ${
                    item.total_glaze > 0
                      ? '#FFD84D'
                      : item.is_prod_backlog == 1
                      ? '#4CAF50'
                      : ''
                  }`"
                  @click="
                    (roles.includes(userRoleIdAdmin) ||
                      roles.includes(userRoleIdPanelAdmin) ||
                      roles.includes(userRoleIdAssociate)) &&
                    item.total_glaze > 0
                      ? openFinishedGoodForm(item, 6)
                      : ''
                  "
                >
                  <span v-if="item.total_glaze > 0" style="color: #000000">{{
                    item.total_glaze
                  }}</span>
                  <span
                    v-else-if="item.is_prod_backlog == 1"
                    style="color: #ffffff"
                    >G</span
                  >
                  <span v-else style="color: #000000" />
                </v-btn>
              </v-col> -->
            </v-row>
            <!-- <v-row
              style="border-bottom: 1px solid rgba(0, 0, 0, 0.1)"
              align="center"
            >
              <v-col cols="4" style="line-height: 16px">
                <span style="font-size: 16px; color: rgba(0, 0, 0, 0.8)"
                  >Prod.Backlog</span
                >
              </v-col>
              <v-col style="line-height: 16px">
                <v-btn
                  v-if="item.production_backlog || item.production_backlog == 0"
                  elevation="0"
                  fab
                  outlined
                  tile
                  :style="`border-radius: 4px; width: 25px; height: 25px; border: 1.5px solid ${
                    item.total_prod_backlog != 0 ? '#EF5350' : '#4CAF50'
                  }; background-color: ${
                    item.total_prod_backlog != 0 ? '#EF5350' : '#4CAF50'
                  } ;`"
                >
                  <span style="color: #ffffff">{{
                    item.production_backlog || item.production_backlog == 0
                      ? item.production_backlog
                      : ''
                  }}</span>
                </v-btn>
                <a v-else>-</a>
              </v-col>
            </v-row>
            <v-row style="border-bottom: 1px solid rgba(0, 0, 0, 0.1)">
              <v-col cols="4" style="line-height: 16px">
                <span style="font-size: 16px; color: rgba(0, 0, 0, 0.8)"
                  >Ship.Backlog</span
                >
              </v-col>
              <v-col style="line-height: 16px">
                <v-btn
                  v-if="item.shipping_backlog || item.shipping_backlog == 0"
                  elevation="0"
                  fab
                  outlined
                  tile
                  readonly
                  :style="`cursor: default; border-radius: 4px; width: 25px; height: 25px; border: 1.5px solid ${
                    item.total_shipping != 0 ? '#EF5350' : '#4CAF50'
                  }; background-color: ${
                    item.total_shipping != 0 ? '#EF5350' : '#4CAF50'
                  };`"
                >
                  <span style="color: #ffffff">{{
                    item.shipping_backlog || item.shipping_backlog == 0
                      ? item.shipping_backlog
                      : ''
                  }}</span>
                </v-btn>
                <a v-else>-</a>
              </v-col>
            </v-row> -->
            <!-- <v-row style="border-bottom: 1px solid rgba(0, 0, 0, 0.1)">
              <v-col cols="4" style="line-height: 16px">
                <span style="font-size: 16px; color: rgba(0, 0, 0, 0.8)"
                  >Planned Ship Date</span
                >
              </v-col>
              <v-col style="line-height: 16px">
                <span
                  style="font-size: 16px; color: #000000; line-height: 10px"
                  >{{ item.planned_ship_date_short }}</span
                >
              </v-col>
            </v-row> -->
            <v-row v-if="item.last_note" align="center">
              <v-col cols="4" style="line-height: 16px">
                <span style="font-size: 16px; color: rgba(0, 0, 0, 0.8)"
                  >Note</span
                >
              </v-col>
              <v-col style="line-height: 16px">
                <span style="color: rgb(255, 152, 0)">
                  <v-btn icon small @click="openNotes(item)">
                    <v-icon small style="color: rgb(255, 152, 0)">
                      mdi-eye
                    </v-icon>
                  </v-btn></span
                >
                <span>{{ item.last_note }}</span>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-form>
    </v-dialog>
    <confirm-form ref="confirmForm" />
    <wip-panel-schedule-form ref="wipPanelScheduleForm" @success="get()" />
    <note-form v-show="false" ref="noteForm" @success="get()" />
    <wip-panel-schedule-item-form ref="wipPanelScheduleItemForm" />
  </v-row>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import WipPanelScheduleForm from '@/components/forms/wipPanelSchedules/WipPanelScheduleForm';
import WipPanelScheduleItemForm from '@/components/forms/wipPanelSchedules/WipPanelScheduleItemForm.vue';
import NoteForm from '@/components/forms/notes/NoteForm.vue';

export default {
  components: {
    WipPanelScheduleForm,
    WipPanelScheduleItemForm,
    NoteForm,
  },
  props: {},
  data: () => ({
    item: null,
    itemId: null,
    dialog: false,
    statusIdInProgress: 1,
    statusIdComleted: 2,
    noteStatusIdShort: 2,
    materialAvailableId: 1,
    cutId: 2,
    assembleId: 3,
    spandrelId: 4,
    panelsId: 5,
    tAndBId: 6,
    glazedId: 7,
    roles: [],
    userRoleIdAdmin: 3,
    userRoleIdAssociate: 6,
    userRoleIdGlassHandler: 13,
    userRoleIdProductionSupervisor: 18,
    userRoleIdSplanderPaintSupervisor: 21,
    userRoleIdProductionAdmin: 22,
    userRoleIdPanelAdmin: 38,
    glassStatusIdNew: 1,
    glassStatusIdInProduction: 2,
    glassStatusIdProduced: 3,
    glassStatusIdCanceled: 4,
    glassStatusIdRemake: 5,
    glassStatusIdShipped: 6,
    glassStatusIdReceived: 7,
    glassStatusIdCutting: 10,
    glassStatusIdTempering: 11,
    glassStatusIdShippedToSite: 12,
    glassStatusIdReceivedOnSite: 13,
    glassStatusIdIssued: 17,
    glassStatusIdPShipped: 8,
    glassStatusIdPReceived: 9,
    glassStatusIdPShippedToSite: 14,
    glassStatusIdPReceivedOnSite: 15,
    glassStatusIdRejected: 16,
    noteTypeIdWipPanelSchedule: 10,
  }),
  computed: {
    ...mapState({
      user: (state) => state.user,
    }),
    ...mapGetters([]),
    isAdmin() {
      return this.roles.includes(this.userRoleIdAdmin)
          || this.roles.includes(this.userRoleIdPanelAdmin)
    },
    stages() {
      return [
        { statusId: this.glassStatusIdNew, letter: 'C', name: 'CUT' },
        { statusId: this.glassStatusIdCutting, letter: 'P', name: 'PRD' },
        { statusId: this.glassStatusIdProduced, letter: 'S', name: 'SHP' },
        { statusId: this.glassStatusIdShipped, letter: 'R', name: 'REC' },
        { statusId: null, letter: '' },
        { statusId: this.glassStatusIdReceived, letter: 'S', name: 'STS' },
        { statusId: this.glassStatusIdShippedToSite, letter: 'R', name: 'ROS' },
      ];
    },
  },
  watch: {},
  created() {
    this.roles = this.user.roles.map((x) => x.id);
  },
  methods: {
    async get() {
      if (!this.itemId) return;
      const submitModel = {
        filters: {
          id: this.itemId,
        },
      };
      const res = await this.$api.wipPanelSchedule.read(submitModel);
      const firstIndex = 0;
      if (!res || !res.data || res.data.length === 0) {
        return;
      }
      res.data[firstIndex].total_new = parseInt(res.data[firstIndex].total_new, 10);
      res.data[firstIndex].total_cutting = parseInt(res.data[firstIndex].total_cutting, 10);
      res.data[firstIndex].total_produced = parseInt(res.data[firstIndex].total_produced, 10);
      res.data[firstIndex].total_shipped = parseInt(res.data[firstIndex].total_shipped, 10);
      res.data[firstIndex].total_received = parseInt(res.data[firstIndex].total_received, 10);
      res.data[firstIndex].total_shipped_to_site = parseInt(res.data[firstIndex].total_shipped_to_site, 10);
      res.data[firstIndex].total_received_on_site = parseInt(res.data[firstIndex].total_received_on_site, 10);
      
      this.item = res.data[firstIndex];
    },

    async open(id) {
      this.itemId = id;
      await this.get();
      this.dialog = true;
    },

    close() {
      this.dialog = false;
      this.$emit('success');
    },

    openEdit(item) {
      if (item.job_id) {
        this.$refs.wipPanelScheduleForm.open(item.id);
      } else {
        this.$bus.$emit(
          'showError',
          'Cannot edit record without job assigned.'
        );
      }
    },

    openNotes(item) {
      this.$refs.noteForm.open(
        item.id,
        this.noteTypeIdWipPanelSchedule,
      );
    },

    async softDelete(id) {
      const confirm = await this.$refs.confirmForm.open({
        title: 'Are you sure that you want to delete this record?',
      });
      if (!confirm) return;
      this.$bus.$emit('loading');
      const res = await this.$api.wipPanelSchedule.delete(id);
      this.$bus.$emit('loading');
      if (!res) {
        this.$bus.$emit('showError');
        return;
      }
      this.$bus.$emit('showSuccess');
      this.get();
    },

    async toggle(id, statusId) {
      const confirm = await this.$refs.confirmForm.open({
        title: `Are you sure that you want to ${
          statusId === this.statusIdInProgress ? 'COMPLETE' : 'RESTORE'
        }?`,
      });
      if (!confirm) return;
      const res = await this.$api.wipPanelSchedule.get(`toggle/${id}/${statusId}`);
      if (!res) {
        this.$bus.$emit('showError');
        return;
      }
      this.$bus.$emit('showSuccess');
      this.close();
    },

    getItemColor(item) {
      if (item.is_glaze === 1 && item.total_glaze === 0) {
        return '#0BDE79';
      }
      if (item.is_t_and_b === 1 && item.total_t_and_b === 0) {
        return '#F7E800';
      }
      if (item.is_assemble === 1 && item.total_assemble === 0) {
        return '#9C27B0';
      }
      if (item.is_cut === 1 && item.total_cut === 0) {
        return '#00BFA5';
      }
      if (item.is_material_available === 1 && item.total_material === 0) {
        return '#1870CB';
      }
      return '#F7A51C';
    },

    getItemName(item) {
      if (item.is_glaze === 1 && item.total_glaze === 0) {
        return 'COMPLETE';
      }
      if (item.is_t_and_b === 1 && item.total_t_and_b === 0) {
        return 'GLAZE';
      }
      if (item.is_assemble === 1 && item.total_assemble === 0) {
        return 'T & B';
      }
      if (item.is_cut === 1 && item.total_cut === 0) {
        return 'ASSEMBLY';
      }
      if (item.is_material_available === 1 && item.total_material === 0) {
        return 'CUT';
      }
      return 'MATERIAL';
    },

    getFontColor(item) {
      if (item.is_glaze === 1 && item.total_glaze === 0) {
        return '#000';
      }
      if (item.is_t_and_b === 1 && item.total_t_and_b === 0) {
        return '#000';
      }
      if (item.is_assemble === 1 && item.total_assemble === 0) {
        return '#000';
      }
      if (item.is_cut === 1 && item.total_cut === 0) {
        return '#FFF';
      }
      if (item.is_material_available === 1 && item.total_material === 0) {
        return '#FFF';
      }
      return '#FFF';
    },

    openItemsForm(item, statusId) {
      let statusIds = [];
      switch (statusId) {
        case this.glassStatusIdNew || this.glassStatusIdIssued:
          statusIds = [this.glassStatusIdNew, this.glassStatusIdIssued];
          break;
        case this.glassStatusIdCutting:
          statusIds = [this.glassStatusIdCutting, this.glassStatusIdNew, this.glassStatusIdIssued];
          break;
        case this.glassStatusIdTempering:
          statusIds = [this.glassStatusIdCutting, this.glassStatusIdTempering, this.glassStatusIdNew, this.glassStatusIdIssued];
          break;

        case this.glassStatusIdProduced:
          statusIds = [this.glassStatusIdCutting, this.glassStatusIdTempering, this.glassStatusIdProduced, this.glassStatusIdNew, this.glassStatusIdIssued];
          break;

        case this.glassStatusIdShipped:
          statusIds = [this.glassStatusIdCutting, this.glassStatusIdTempering, this.glassStatusIdProduced, this.glassStatusIdShipped, this.glassStatusIdNew, this.glassStatusIdReceived, this.glassStatusIdIssued];
          break;

        case this.glassStatusIdReceived:
          statusIds = [this.glassStatusIdCutting, this.glassStatusIdTempering, this.glassStatusIdProduced, this.glassStatusIdShipped, this.glassStatusIdReceived, this.glassStatusIdNew, this.glassStatusIdIssued];
          break;

        case this.glassStatusIdShippedToSite:
          statusIds = [this.glassStatusIdReceivedOnSite, this.glassStatusIdCutting, this.glassStatusIdTempering, this.glassStatusIdProduced, this.glassStatusIdShipped, this.glassStatusIdReceived, this.glassStatusIdShippedToSite, this.glassStatusIdNew, this.glassStatusIdIssued];
          break;

        case this.glassStatusIdReceivedOnSite:
          statusIds = [this.glassStatusIdCutting, this.glassStatusIdTempering, this.glassStatusIdProduced, this.glassStatusIdShipped, this.glassStatusIdReceived, this.glassStatusIdShippedToSite, this.glassStatusIdReceivedOnSite, this.glassStatusIdNew, this.glassStatusIdIssued];
          break;

        case this.glassStatusIdRejected:
          statusIds = [this.glassStatusIdRejected];
          break;

        default:
          statusIds = [statusId];
          break;
      }
      this.$refs.wipPanelScheduleItemForm.open(item, statusIds);
    },

    getStageClass(item, stage) {
      switch (stage.statusId) {
        case this.glassStatusIdNew || this.glassStatusIdIssued:
          if (item.total_new !== 0) return 'yellow-box';
          if (this.getStatusValue(stage.statusId, item.wip_panel_grouped_status_id) === 1) return 'green-box';
          return 'empty-box';
        case this.glassStatusIdCutting:
          if (item.total_cutting !== 0) return 'yellow-box';
          if (this.getStatusValue(stage.statusId, item.wip_panel_grouped_status_id) === 1 && item.total_new === 0) return 'green-box';
          if (this.getStatusValue(stage.statusId, item.wip_panel_grouped_status_id) === 1 && item.total_new !== 0) return 'yellow-box';
          return 'empty-box';
        case this.glassStatusIdTempering:
          if (item.total_tempering !== 0) return 'yellow-box';
          if (this.getStatusValue(stage.statusId, item.wip_panel_grouped_status_id) === 1 && item.total_new === 0 && item.total_cutting === 0) return 'green-box';
          if (this.getStatusValue(stage.statusId, item.wip_panel_grouped_status_id) === 1 && (item.total_new !== 0 || item.total_cutting !== 0)) return 'yellow-box';
          return 'empty-box';
        case this.glassStatusIdProduced:
          //this is under SHP header
          if (item.total_produced !== 0) return 'yellow-box';
          if (this.getStatusValue(stage.statusId, item.wip_panel_grouped_status_id) === 1 && item.total_new === 0 && item.total_cutting === 0) return 'green-box';
          if (this.getStatusValue(stage.statusId, item.wip_panel_grouped_status_id) === 1 && (item.total_new !== 0 || item.total_cutting !== 0)) return 'yellow-box';
          return 'empty-box';
        case this.glassStatusIdShipped:
          // eslint-disable-next-line no-case-declarations
          const total = item.total_received + item.total_shipped_to_site + item.total_received_on_site;
          if (total !== 0 && item.wip_panel_quantity !== 0 && total === item.wip_panel_quantity) return 'green-box';
          if (item.total_shipped !== 0 || item.total_received !== 0) return 'yellow-box';
          if (this.getStatusValue(stage.statusId, item.wip_panel_grouped_status_id) === 1 && item.total_new === 0 && item.total_cutting === 0 && item.total_produced === 0) return 'green-box';
          if (this.getStatusValue(stage.statusId, item.wip_panel_grouped_status_id) === 1 && (item.total_new !== 0 || item.total_cutting !== 0 || item.total_produced !== 0)) return 'yellow-box';
          return 'empty-box';
        case this.glassStatusIdReceived:
          if (item.total_received !== 0 && item.total_shipped_to_site !== 0) return 'yellow-box';
          if (this.getStatusValue(stage.statusId, item.wip_panel_grouped_status_id) === 1 && item.total_received === 0 && item.total_new === 0 && item.total_cutting === 0 && item.total_produced === 0 && item.total_shipped === 0) return 'green-box';
          if (this.getStatusValue(stage.statusId, item.wip_panel_grouped_status_id) === 1 && (item.total_new !== 0 || item.total_cutting !== 0 || item.total_produced !== 0 || item.total_received !== 0) && item.total_shipped_to_site !== 0) return 'yellow-box';
          return 'empty-box';
        case this.glassStatusIdShippedToSite:
          if (item.total_received_on_site !== 0 && item.wip_panel_quantity !== 0 && item.total_received_on_site === item.wip_panel_quantity) return 'green-box';
          if (item.total_shipped_to_site !== 0 || item.total_received_on_site !== 0) return 'yellow-box';
          return 'empty-box';
        case this.glassStatusIdRejected:
          if (item.total_rejected !== 0) return 'red-box';
          return 'empty-box';
        default:
          return 'empty-box';
      }
    },

    getStageValue(item, stage) {
      switch (stage.statusId) {
        case this.glassStatusIdNew || this.glassStatusIdIssued:
          if (item.total_new !== 0) return item.total_new;
          if (this.getStatusValue(stage.statusId, item.wip_panel_grouped_status_id) === 1) return stage.letter;
          return '';
        case this.glassStatusIdCutting:
          if (item.total_cutting !== 0) return item.total_cutting + item.total_new;
          if (this.getStatusValue(stage.statusId, item.wip_panel_grouped_status_id) === 1 && item.total_new === 0) return stage.letter;
          if (this.getStatusValue(stage.statusId, item.wip_panel_grouped_status_id) === 1 && item.total_new !== 0) return item.total_new;
          return '';
        case this.glassStatusIdProduced:
          if (item.total_produced !== 0) return item.total_produced + item.total_cutting + item.total_new;
          if (this.getStatusValue(stage.statusId, item.wip_panel_grouped_status_id) === 1 && item.total_new === 0 && item.total_cutting === 0) return stage.letter;
          if (this.getStatusValue(stage.statusId, item.wip_panel_grouped_status_id) === 1 && (item.total_new !== 0 || item.total_cutting !== 0)) return item.total_cutting + item.total_new;
          return '';
        case this.glassStatusIdShipped:
          // eslint-disable-next-line no-case-declarations
          const total = item.total_received + item.total_shipped_to_site + item.total_received_on_site;
          if (total !== 0 && item.wip_panel_quantity !== 0 && total === item.wip_panel_quantity) return stage.letter;
          if (item.total_shipped !== 0 || item.total_received !== 0) return item.total_received + item.total_shipped + item.total_produced + item.total_cutting + item.total_new;
          if (this.getStatusValue(stage.statusId, item.wip_panel_grouped_status_id) === 1 && item.total_new === 0 && item.total_cutting === 0 && item.total_produced === 0) return stage.letter;
          if (this.getStatusValue(stage.statusId, item.wip_panel_grouped_status_id) === 1 && (item.total_new !== 0 || item.total_cutting !== 0 || item.total_produced !== 0)) return item.total_produced + item.total_cutting + item.total_new;
          return '';
        case this.glassStatusIdReceived:
          if (item.total_received !== 0 && item.total_shipped_to_site !== 0) return item.total_received + item.total_shipped + item.total_produced + item.total_cutting + item.total_new;
          if (this.getStatusValue(stage.statusId, item.wip_panel_grouped_status_id) === 1 && item.total_received === 0 && item.total_new === 0 && item.total_cutting === 0 && item.total_produced === 0 && item.total_shipped === 0) return stage.letter;
          if (this.getStatusValue(stage.statusId, item.wip_panel_grouped_status_id) === 1 && (item.total_new !== 0 || item.total_cutting !== 0 || item.total_produced !== 0 || item.total_received !== 0) && item.total_shipped_to_site !== 0) return item.total_received + item.total_produced + item.total_cutting + item.total_new;
          return '';
        case this.glassStatusIdShippedToSite:
          if (item.total_received_on_site !== 0 && item.wip_panel_quantity !== 0 && item.total_received_on_site === item.wip_panel_quantity) return stage.letter;
          if (item.total_shipped_to_site !== 0 || item.total_received_on_site !== 0) return item.total_received_on_site + item.total_shipped_to_site + item.total_received + item.total_shipped + item.total_produced + item.total_cutting + item.total_new;
          return '';
        default:
          return '';
      }
    },

    //if the status of the production schedule is greater than the stage status, return 1 else return 0
    getStatusValue(statusId, itemStatusId) {
      const statusesInOrder = [
        this.glassStatusIdNew,
        this.glassStatusIdCutting,
        this.glassStatusIdTempering,
        this.glassStatusIdInProduction,
        this.glassStatusIdProduced,
        this.glassStatusIdShipped,
        this.glassStatusIdPShipped,
        this.glassStatusIdReceived,
        this.glassStatusIdPReceived,
        this.glassStatusIdShippedToSite,
        this.glassStatusIdPShippedToSite,
        this.glassStatusIdReceivedOnSite,
        this.glassStatusIdPReceivedOnSite,
      ];

      const statusIndex = statusesInOrder.findIndex((x) => x === statusId);
      const itemStatusIndex = statusesInOrder.findIndex((x) => x === itemStatusId);

      return statusIndex < itemStatusIndex ? 1 : 0;
    },
  },
};
</script>

<style scoped>
#cellOverflow {
  position: sticky !important;
  position: -webkit-sticky !important;
  right: 0;
  min-width: 120px !important;
  border-left: 1px solid #e0e0e0;
  background-color: #fafafa;
}

#cellOverflow.theme--dark {
  background-color: #323232;
}

span {
  font-size: 12px !important;
}
::v-deep
  .theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > thead
  > tr:last-child
  > th {
  background-color: #323232;
}

::v-deep
  .theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > thead
  > tr:last-child
  > th
  > span {
  color: #ffffff;
}

::v-deep .theme--light.v-divider {
  border-color: rgba(0, 0, 0, 0.4) !important;
  border: 1px solid rgba(0, 0, 0, 0.4) !important;
}

:v-deep .v-btn__content {
  color: white !important;
}

.box {
  border-radius: 4px;
  width: 25px;
  height: 25px;
}

.empty-box {
  border: 1.5px solid #ffd84d;
  background-color: #ffffff;
}

.empty-box span {
  color: #000000;
}

.red-box {
  border: 1.5px solid #f44336;
  background-color: #f44336;
}

.yellow-box {
  border: 1.5px solid #ffd84d;
  background-color: #ffd84d;
}

.yellow-box span {
  color: #000000;
}

.green-box {
  border: 1.5px solid #4caf50;
  background-color: #4caf50;
}

.green-box span {
  color: #ffffff;
}
</style>
